import { MotionProps, m as motion } from "motion/react";
import styles from "./play-button-indicator.module.less";

type TPlayButtonIndicatorProps = {
  className?: string;
  animation?: MotionProps;
};

export const PlayButtonIndicator = ({ className, animation }: TPlayButtonIndicatorProps) => {
  return (
    <motion.div {...animation} className={[styles.playButtonWrapper, className ?? ""].join(" ")}>
      <div className={styles.playButtonBackground} />
      <span className={[styles.icon, "ui-icon-play"].join(" ")} />
    </motion.div>
  );
};

export default PlayButtonIndicator;
